

// auth.js
const isAuthenticated = () => {
    return !!localStorage.getItem("token") || !!sessionStorage.getItem('token') ;
};

// Function to get the auth token (this can be modified based on where you store the token)
const getAuthToken = () => {
    return localStorage.getItem('token') || sessionStorage.getItem('token') ; // Or wherever you store your token
  };

  //Function to get usertype from localstorage
  const getUserType = () => {
     return localStorage.getItem('usertype') || sessionStorage.getItem('usertype'); // Or wherever you store your token
  };

  // Function to set up headers
  const getHeaders = () => {
    const token = getAuthToken();
    return {
      headers: {
        Authorization: `Bearer ${token}`, // Assuming Bearer token
      },
    };
  };

const isTokenExpired=()=> {
  const expirationTime = localStorage.getItem("expirationTime") || sessionStorage.getItem("expirationTime");
  if (!expirationTime) return true;
  return Date.now() > parseInt(expirationTime);
}

const logout=() =>{
  localStorage.removeItem("token");
  localStorage.removeItem("expirationTime");
  localStorage.removeItem("uname");
  localStorage.removeItem("usertype");

  sessionStorage.removeItem("token");
  sessionStorage.removeItem("expirationTime");
  sessionStorage.removeItem("uname");
  sessionStorage.removeItem("usertype");
}

  export {
    isAuthenticated,
    getAuthToken,
    getHeaders,
    isTokenExpired,
    getUserType,
    logout,
    
      }

